export default {
    mutations: {
        SOCKET_ONMESSAGE(state, message, rootState) {
            state.socket.message = message;
        },
        SOCKET_ONOPEN(state, event) {
            state.socket.isConnected = true;
        },
        SOCKET_ONCLOSE(state, event) {
            state.socket.isConnected = false;
        },
        SOCKET_ONERROR(state, event) {
        },
        SOCKET_RECONNECT(state, count) {
        },
        SOCKET_RECONNECT_ERROR(state) {
            state.socket.reconnectError = true;
        },
        /*[SOCKET_SEND_MESSAGE](state, message) {
            state.socket.isConnected && Vue.prototype.$socket.sendObj(message);
        }*/
    },
    state: {
        socket: {
            message: {},
            isConnected: false,
            reconnectError: false
        }
    },
    getters: {
        socket:(state) => state.socket,
    },
}